<template>
    <div class="modal fade" :id="idModalReport" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content" :class="[is_loading ? 'loading':'']">
                <transition name="slide">
                    <div v-if="!is_loading">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalCenterTitle">{{ title }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            {{ content }} <br> Numero de Transaccion {{ idReport }}
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                            <button type="button" class="btn btn-primary" :disabled="idReport>0 ? false:true" @click="mCallReport2">Reporte</button>
                        </div>
                    </div>
                    <div v-else>
                        <div align="center">
                            <div class="loader-back">
                                <div class="loader"></div>
                            </div>
                        </div>
                        <div align="center">
                            <p class="letter-loading">Solicitando ...</p>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
const qs= require('qs');

export default {
    name:'modal-report',
    props:{
        idModalReport:String,
        title:String,
        content:String,
        idReport:Number,
        urlR:String
    },
    data(){
        return {
            is_loading:false
        }
    },
    methods:{
        mCallReport2(){
          let url_report=btoa(`${this.urlR}/${this.idReport}`);
          // let url_report=btoa(`pdfOrdopI/${id}`)
          let route = this.$router.resolve({path: `/report/${url_report}`});
          
          window.open(route.href, 'reporte', 'location=no,toolbar=no,menubar=no,scrollbars=yes,resizable=yes,addressbar=0,titlebar=no,directories=no,channelmode=no,status=no');
        },
        callReport(){
            this.mActiveLoading();
            
            // axios.get(`${this.urlR}/${this.idReport}`,
            // console.log(`${this.urlR}/${this.idReport}`);
            axios.get(`${this.urlR}/${this.idReport}?api_token=${Vue.auth.getToken()}`,
                {
                    responseType:'blob'
                })
                .then(res => {
                    // console.log(res)
                    // const url = window.URL.createObjectURL(new Blob([res.data]));
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Reporte.pdf');
                    document.body.appendChild(link);
                    link.click();
                    this.mHideLoading();
                })
                .catch(error => {
                    console.log(error);
                    this.mHideLoading();
                })
        },
        mActiveLoading(){
            this.is_loading=true;
        },
        mHideLoading(){
            this.is_loading=false;
        }
    }
    
}
</script>

<style>
.loading{
    background:transparent;
    border:none;
}

.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid white;
  border-bottom: 16px solid white;
  border-left: 16px solid blue;
  border-right: 16px solid blue;
  width: 145px;
  height: 145px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

.loader-back{
    
    border-radius: 50%;
    
    background-image: url("../../assets/images/load_dgcp.png");
    width:148px;
    height:148px;
    background-repeat: no-repeat; /* Do not repeat the image */
    background-size: cover;
    background-position: center; 
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}

.letter-loading {
      
      font-family: arial;
      font-style: italic;
      
      width:100%;
      
      margin: 0 auto;
      text-align: center;
      
      color:white;
      font-size:15px;
      font-weight: bold;
      position: absolute;
      -webkit-animation:colorchange 20s infinite alternate;      
      animation:colorchange 20s infinite alternate;
      
    }

    @-webkit-keyframes colorchange {
      0% {        
        color:white;
      }      
      10% {        
        color: red;
      }      
      20% {        
        color: yellow;
      }      
      30% {        
        color:green;
      }      
      40% {        
        color:white;
      }      
      50% {        
        color: #2980b9;
      }      
      60% {        
        color:red;
      }      
      70% {        
        color: yellow;
      }
      80% {     
        color: green;
      }      
      90% {     
        color: #2980b9;
      }      
      100% {        
        color: white;
      }
    }

    @keyframes colorchange {
      0% {        
        color:white;
      }      
      10% {        
        color: red;
      }      
      20% {        
        color: yellow;
      }      
      30% {        
        color:green;
      }      
      40% {        
        color:white;
      }      
      50% {        
        color: #2980b9;
      }      
      60% {        
        color:red;
      }      
      70% {        
        color: yellow;
      }
      80% {     
        color: green;
      }      
      90% {     
        color: #2980b9;
      }      
      100% {        
        color: white;
      }
    }

</style>




// WEBPACK FOOTER //
// src/components/modal/modalReport.vue